import Loadable from "@loadable/component";

const ProductMobileSizes = Loadable(
  () =>
    import(
      /* webpackChunkName: "product_mobile_sizes_component" */ "./productMobileSizes"
    )
);

export default ProductMobileSizes;
